<rx-row>
  <div
    rxUpload
    *ngIf="!isLoading; else loader"
    class="image-preview mr20"
    name="img-upload-0"
    id="upload-img"
    [class.disabled]="disabled"
    [accept]="'image/*'"
    [disabled]="disabled"
    [style.backgroundImage]="'url(' + (photoUrl || defaultImg || '/assets/icons/icon-camera-circle.svg') + ')'"
    (checkedChange)="handleChangeInput()"
    (uploadedFiles)="handleFileInput($event)"
  ></div>
  <rx-col>
    <span class="mb10 description"> 400x400 for best resolution </span>
    <div class="upload-btn-container">
      <div
        class="mr20"
        rxUpload
        (checkedChange)="handleChangeInput()"
        (uploadedFiles)="handleFileInput($event)"
        [disabled]="disabled"
        [accept]="'image/png, image/jpeg'"
      >
        <rx-button class="light-blue upload-btn" [id]="id + '-new'" [disabled]="disabled"> Upload New </rx-button>
      </div>
      <rx-button
        *ngIf="photoUrl"
        class="red delete-btn"
        [id]="id + '-delete'"
        [disabled]="disabled"
        (clicked)="deletePhoto()"
      >
        Delete
      </rx-button>
    </div>
  </rx-col>
</rx-row>

<ng-template #loader>
  <div class="spinner mr20">
    <div class="spinner__content">
      <rx-icon name="icon-spinner"></rx-icon>
    </div>
    <div class="spinner__backdrop"></div>
  </div>
</ng-template>
